import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  placeBetVideoPokerService, getMyBetsService, getUnfinishedBetService,
  dealVideoPokerService
} from 'games/VidePoker/services/videoPoker.service'
import { openErrorToaster, openSuccessToaster } from 'utils/common-services/toaster.service'
import { BET_RESULT } from 'utils/constants/index'
import { setPokerLossCount, setPokerProfit, setPokerWagered, setPokerWinsCount } from './videoPoker.slice'
import { creditBalance, debitBalance } from 'redux-store/redux/slices/auth.slice'

export const placeBetVideoPoker = createAsyncThunk('video-poker-game/place-bet', async ({ data, onSuccess, setLocking, lockingRef }, thunkApi) => {
  try {
    const res = await placeBetVideoPokerService(data)
    if (res) {
      thunkApi.dispatch(setPokerWagered(res?.betAmount))
      thunkApi.dispatch(debitBalance(res?.betAmount))
    }
    openSuccessToaster({
      message: 'Bet Placed successfully'
    })
    onSuccess(res)
    return res
  } catch (error) {
    lockingRef.current.bet = false
    setLocking(prev => ({ ...prev, bet: false }))
    return thunkApi.rejectWithValue(error[0].description)
  }
}
)

export const dealVideoPoker = createAsyncThunk('video-poker-game/deal', async ({ payload, setLocking, lockingRef }, thunkApi) => {
  try {
    const res = await dealVideoPokerService(payload)
    setTimeout(() => {
      if (res?.result === BET_RESULT.WON) {
        thunkApi.dispatch(setPokerWinsCount())
        thunkApi.dispatch(setPokerProfit(res))
        openSuccessToaster({
          message: `${res?.winHandType}`
        })
        thunkApi.dispatch(creditBalance(res?.winningAmount))
      } else {
        thunkApi.dispatch(setPokerLossCount())
        thunkApi.dispatch(setPokerProfit(res))
        openErrorToaster({
          message: 'You Lost'
        })
      }
    }, 2000)

    return res
  } catch (error) {
    lockingRef.current.deal = false
    setLocking(prev => ({ ...prev, deal: false }))
    return thunkApi.rejectWithValue(error[0].description)
  }
}
)

export const getVideoPokerBets = createAsyncThunk('video-poker-game/my-bets', async (data, thunkApi) => {
  try {
    const res = await getMyBetsService(data)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
}
)

export const getUnfinishedBet = createAsyncThunk('video-poker-game/unfinished-bet', async (data, thunkApi) => {
  try {
    const res = await getUnfinishedBetService()
    if (res?.hasUnfinishedBet) {
      openSuccessToaster({
        message: 'You already have a Bet Placed.'
      })
    }
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
